export default {
      id: "city-icon-7-usage",
      viewBox: "0 0 55 80",
      url: __webpack_public_path__ + "sprite.svg#city-icon-7",
      toString: function () {
        return this.url;
      }
    }